app.service("ENV", [
	function () {
		var service = {};

		if (window.location.origin.indexOf("localhost") !== -1) {
			service.API = "https://dev.cattrax.co.nz/cattrax-rest-api"; 
			service.API = "http://localhost:8080/cattrax-rest-api"; 
		} else {
			service.API = "cattrax-rest-api";
		}

		service.TEST_DATA_ENABLED = window.location.origin.indexOf("localhost") !== -1
			|| window.location.origin.indexOf("dev.") !== -1;

		if (window.location.origin === "https://www.cattrax.co.nz" || window.location.origin === "https://www.au.cattrax.co.nz") {
			service.ENVIRONMENT = 'PROD';
			service.TAG = "GTM-PNZKFMK";
			service.MEDIPASS_ENV = "prod";
			service.BIOMAPI_URL = "https://biomapi.com";
			service.BIOMAPI_INTEGRATOR_ID = "cattrax";
			service.BIOMAPI_INTEGRATOR_NAME = "CatTrax";
			service.BIOMAPI_IOL_CALCULATOR_URL = "https://iolcalculator.escrs.org/";
			service.STRIPE_CARD_INITIATE_ID = "prctbl_1RQziPQ24oBD89GKnLmvGwyj"
			service.STRIPE_CARD_INITIATE_KEY = "pk_live_51R4BB2LFikLGtuZMXyeIPXoU9MEYxi7W64AFlmtZfUqGqmOJZMSnjB1CzaEJUH6LM4hmVdKmOQImqyy8VDiDd3NM00AvbN2uuD"
			service.STRIPE_SMS_TOKEN_PRICING_ID = "prctbl_1RHB1JLFikLGtuZMkZHIxLRK"
			service.STRIPE_SMS_TOKEN_PRICING_KEY = "pk_live_51R4BB2LFikLGtuZMXyeIPXoU9MEYxi7W64AFlmtZfUqGqmOJZMSnjB1CzaEJUH6LM4hmVdKmOQImqyy8VDiDd3NM00AvbN2uuD"
			service.STRIPE_PREMIUM_USER_PRICING_ID = "prctbl_1RQyHmLFikLGtuZMZHsrXp2f"
			service.STRIPE_PREMIUM_USER_PRICING_KEY = "pk_live_51R4BB2LFikLGtuZMXyeIPXoU9MEYxi7W64AFlmtZfUqGqmOJZMSnjB1CzaEJUH6LM4hmVdKmOQImqyy8VDiDd3NM00AvbN2uuD"
			service.STRIPE_PREMIUM_USER_CUSTOMER_PORTAL = "https://billing.stripe.com/p/login/00g7vB9FI96L2li288"
		} else {
			service.ENVIRONMENT = 'DEV';
			service.TAG = "GTM-M3MBBJJ";
			service.MEDIPASS_ENV = "stg";
			service.BIOMAPI_URL = "https://biomapi.com";
			service.BIOMAPI_INTEGRATOR_ID = "cattrax-dev";
			service.BIOMAPI_INTEGRATOR_NAME = "CatTrax (dev)";
			service.BIOMAPI_IOL_CALCULATOR_URL = "https://iolcalculator.escrs.org/";
			service.STRIPE_CARD_INITIATE_ID = "prctbl_1RQziPQ24oBD89GKnLmvGwyj"
			service.STRIPE_CARD_INITIATE_KEY = "pk_test_51R4YgBQ24oBD89GK9IRn3JvKbomVr1z8doPT1QCpibZGIcrNuLgNa4SPeUru4xZw3oTNmVTuZXlHUh1uXqlJBmdc00yWVjRkMV"
			service.STRIPE_SMS_TOKEN_PRICING_ID = "prctbl_1RQziPQ24oBD89GKnLmvGwyj"
			service.STRIPE_SMS_TOKEN_PRICING_KEY = "pk_test_51R4YgBQ24oBD89GK9IRn3JvKbomVr1z8doPT1QCpibZGIcrNuLgNa4SPeUru4xZw3oTNmVTuZXlHUh1uXqlJBmdc00yWVjRkMV"
			service.STRIPE_PREMIUM_USER_PRICING_ID = "prctbl_1RQzX1Q24oBD89GK328SZjMI"
			service.STRIPE_PREMIUM_USER_PRICING_KEY = "pk_test_51R4YgBQ24oBD89GK9IRn3JvKbomVr1z8doPT1QCpibZGIcrNuLgNa4SPeUru4xZw3oTNmVTuZXlHUh1uXqlJBmdc00yWVjRkMV"
			service.STRIPE_PREMIUM_USER_CUSTOMER_PORTAL = "https://billing.stripe.com/p/login/test_bIY2b8fQzftJbi8000"
		}

		return service;
	}
]);
